import "./Trama.css"
const Trama = () =>{
return(
    <>
    <h1 className="h1Trama">Trama</h1>
    <h2>¿Que sucede en el prólogo?</h2>
    <article className="Trama">
        <p>El protagonista,que se encontraba recorriendo la última etapa de una excursión,se encuentra al hombre ilustrado,que le contará un poco sobre las ilustraciones en su cuerpo.El resto, se lo contarán ellas mismas. </p>
    </article>
    <h2>Meme</h2>
    <picture>
        <img className="imgTrama" src="../images/Trama.jpeg" alt="MEME"/>
    </picture>
    </>
)
}
export default Trama